"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryAvailabilityToJSON = exports.LibraryAvailabilityFromJSONTyped = exports.LibraryAvailabilityFromJSON = exports.LibraryAvailability = void 0;
/**
 *
 * @export
 */
exports.LibraryAvailability = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED',
    Unsupported: 'UNSUPPORTED'
};
function LibraryAvailabilityFromJSON(json) {
    return LibraryAvailabilityFromJSONTyped(json, false);
}
exports.LibraryAvailabilityFromJSON = LibraryAvailabilityFromJSON;
function LibraryAvailabilityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LibraryAvailabilityFromJSONTyped = LibraryAvailabilityFromJSONTyped;
function LibraryAvailabilityToJSON(value) {
    return value;
}
exports.LibraryAvailabilityToJSON = LibraryAvailabilityToJSON;
